module.exports = __webpack_public_path__ + "wedding_rustic-wedding_1.jpg";